"use strict";

var _slicedToArray = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountdownDisplay = exports.DurationDisplay = exports.splitDurationSegments = exports.TimeDisplayMap = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

function getNumber(time) {
  if (typeof time === "string") {
    return parseInt(time, 10);
  }

  return time;
}

exports.TimeDisplayMap = {
  d: "day",
  h: "hour",
  m: "minute",
  s: "second"
};

var splitDurationSegments = function splitDurationSegments(difference) {
  return {
    d: Math.floor(difference / (3600 * 24)),
    h: Math.floor(difference / 3600) % 24,
    m: Math.floor(difference / 60 % 60),
    s: Math.floor(difference % 60)
  };
};

exports.splitDurationSegments = splitDurationSegments;

var getTimeLeft = function getTimeLeft(to, from) {
  if (from === undefined) {
    return null;
  }

  var difference = to - from;

  if (difference < 0) {
    difference = 0;
  }

  return exports.splitDurationSegments(difference);
};

var DurationDisplay = function DurationDisplay(_ref) {
  var duration = _ref.duration;

  var renderSegmentText = function renderSegmentText(segmentName, segmentValue) {
    if (segmentValue === 0) {
      return "";
    }

    if (segmentValue === 1) {
      return "".concat(segmentValue, " ").concat(exports.TimeDisplayMap[segmentName]);
    }

    return "".concat(segmentValue, " ").concat(exports.TimeDisplayMap[segmentName], "s");
  };

  var durationSegments = exports.splitDurationSegments(duration);
  var singleSegment = Object.values(durationSegments).map(function (segment) {
    return segment === 0;
  }).reduce(function (last, now) {
    return last + (now ? 0 : 1);
  }, 0);

  if (singleSegment <= 1) {
    return jsx_runtime_1.jsx(react_1.Fragment, {
      children: Object.keys(durationSegments).map(function (segment) {
        return (// @ts-ignore: ignoring due to key type erasure with string
          renderSegmentText(segment, durationSegments[segment])
        );
      }).join("")
    }, void 0);
  }

  return jsx_runtime_1.jsx(exports.CountdownDisplay, {
    from: 0,
    to: duration
  }, void 0);
};

exports.DurationDisplay = DurationDisplay;

var CountdownDisplay = function CountdownDisplay(props) {
  var _react_1$useState = react_1.useState(getTimeLeft(getNumber(props.to), getNumber(props.from === undefined ? new Date().getTime() / 1000 : props.from))),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      timeLeft = _react_1$useState2[0],
      setTimeLeft = _react_1$useState2[1];

  var updateTimeLeft = react_1.useCallback(function () {
    setTimeLeft(getTimeLeft(getNumber(props.to), getNumber(props.from === undefined ? new Date().getTime() / 1000 : props.from)));
  }, [props.to, props.from]);
  react_1.useEffect(function () {
    var checkTimeout = setInterval(updateTimeLeft, 1000);
    return function () {
      clearInterval(checkTimeout);
    };
  }, []);

  if (!timeLeft) {
    return jsx_runtime_1.jsx(react_1.Fragment, {}, void 0);
  }

  var timeString = [[timeLeft.d, "d"], [timeLeft.h, "h"], [timeLeft.m, "m"], [timeLeft.s, "s"]].filter(function (n) {
    return n !== null;
  }).reduce(function (lastString, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        number = _ref3[0],
        postfix = _ref3[1];

    if (!lastString.length && number === 0) {
      return "";
    }

    return "".concat(lastString, " ").concat(number).concat(postfix);
  }, "");
  return jsx_runtime_1.jsx(react_1.Fragment, {
    children: timeString || "0s"
  }, void 0);
};

exports.CountdownDisplay = CountdownDisplay;